<!-- =========================================================================================
    File Name: CardBasic.vue
    Description: Basic Cards
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div id="demo-basic-card">
    <vx-card class="box" style="margin-bottom:20px">
      <vs-collapse  v-if="workspaceList.newList.length > 0">
        <vs-collapse-item id='collapse' open>
          <div slot="header">최근 활동 중인 클래스</div>
          <div class="vx-row" style="padding:10px">
            <spaceItem v-for="space in workspaceList.newList" :spaceInfo="space" @delete="deleteWorkspace" v-bind:key="space.id"/>
          </div>
        </vs-collapse-item >
      </vs-collapse>
    </vx-card>
    <vx-card class="box" style="margin-bottom:20px">
      <vs-collapse accordion>
        <vs-collapse-item>
        <div slot="header">개인 클래스</div>
        <div class="vx-row" style="padding:10px">
          <spaceItem v-for="space in workspaceList.aloneList" :spaceInfo="space" @delete="deleteWorkspace" v-bind:key="space.id"/>
        </div>
      </vs-collapse-item>
    </vs-collapse>
  </vx-card>

    <vx-card class="box" style="margin-bottom:20px">
      <vs-collapse accordion>
        <vs-collapse-item>
      <!-- <vx-card title="공유 클래스"> -->
        <div slot="header">공유 클래스</div>
        <div class="vx-row" style="padding:10px">
          <spaceItem v-for="space in workspaceList.teamList" :spaceInfo="space" @delete="deleteWorkspace" v-bind:key="space.id"/>
        </div>
      </vs-collapse-item>
    </vs-collapse>
  </vx-card>
    <vs-prompt
      @cancel="rejectClose"
      @accept="accept"
      @close="close"
      title="클래스 초대"
      accept-text="확인"
      cancel-text="취소"
      :active.sync="activePrompt">
      <div class="con-exemple-prompt">
        <span>{{inviteTitle}}</span><br/>
        <span>초대를 허락하시나요? :)</span>
      </div>
    </vs-prompt>
  </div>
</template>

<script>
import SpaceItem from "@/views/apps/space/SpaceItem.vue"

export default{
  components: {
      'spaceItem': SpaceItem,
  },
  data() {
      return {
        pinNumber: null,
        onInit: true,
        inviteList: [],
        inviteTitle:'',
        activePrompt:false,
        activePromptCount:0,
        intervalObj: null,
        chatMsgInput: '',
        workspaceList: {
          newList : [],
          aloneList : [],
          teamList : []
        },
        defaultInfo: {
          alone:true,
          project:true,
          title:"AClass"
        }
      }
  },

  methods: {
    deleteWorkspace(id){
      var index = this.workspaceList.newList.findIndex((space) => space.id == id)
      this.workspaceList.newList.splice(index,1)

      index = this.workspaceList.aloneList.findIndex((space) => space.id == id)
      this.workspaceList.aloneList.splice(index,1)

      index = this.workspaceList.teamList.findIndex((space) => space.id == id)
      this.workspaceList.teamList.splice(index,1)
    },
    rejectClose(){
      if(this.inviteList[this.activePromptCount].workspace_id){
        this.$store.dispatch('space/agreeInvite', {"workspace_id": this.inviteList[this.activePromptCount].workspace_id,
        "invite_note_id":this.inviteList[this.activePromptCount].id, "agree": false})
      }
      else{
        this.$store.dispatch('project/agreeInvite', {"project_id": this.inviteList[this.activePromptCount].project_id,
        "invite_note_id":this.inviteList[this.activePromptCount].id, "agree": false})
      }
      this.close()
    },
    close(){
      this.activePrompt = false
      this.activePromptCount++
      if (this.activePromptCount < this.inviteList.length) {
        this.inviteTitle = this.inviteList[this.activePromptCount].title
        this.intervalObj = setInterval(() => {
          this.activePrompt = true
          clearInterval(this.intervalObj)
        }, 3)
      } else {
        clearInterval(this.intervalObj)
      }
    },
    accept() {
      this.activePrompt = false
      if(this.inviteList[this.activePromptCount].workspace_id){
        this.inviteWorkspace()
      }else{
        this.inviteProject()
      }
    },
    inviteProject(){
      this.$store.dispatch('project/agreeInvite', {"project_id": this.inviteList[this.activePromptCount].project_id,
      "invite_note_id":this.inviteList[this.activePromptCount].id, "agree": true})
      .then((resolve) => {
        if(resolve){
          if(this.workspaceList.newList.length == 4){
            this.workspaceList.newList.splice(3,1)
          }
          if(this.workspaceList.teamList.length == 4){
            this.workspaceList.teamList.splice(3,1)
          }
          this.workspaceList.newList.unshift(resolve)
          this.workspaceList.teamList.unshift(resolve)
        }
        this.activePromptCount++
        if (this.activePromptCount < this.inviteList.length) {
          this.inviteTitle = this.inviteList[this.activePromptCount].title
          this.intervalObj = setInterval(() => {
            this.activePrompt = true
            clearInterval(this.intervalObj)
          }, 1)
        } else {
          clearInterval(this.intervalObj)
        }
      }).catch(()=>{
        this.activePromptCount++
        if (this.activePromptCount < this.inviteList.length) {
          this.inviteTitle = this.inviteList[this.activePromptCount].title
          this.intervalObj = setInterval(() => {
            this.activePrompt = true
            clearInterval(this.intervalObj)
          }, 1)
        } else {
          clearInterval(this.intervalObj)
        }
      })
    },
    inviteWorkspace(){
      this.$store.dispatch('space/agreeInvite', {"workspace_id": this.inviteList[this.activePromptCount].workspace_id,
      "invite_note_id":this.inviteList[this.activePromptCount].id, "agree": true})
      .then((resolve) => {
        if(this.workspaceList.newList.length == 4){
          this.workspaceList.newList.splice(3,1)
        }
        if(this.workspaceList.teamList.length == 4){
          this.workspaceList.teamList.splice(3,1)
        }
        this.workspaceList.newList.unshift(resolve)
        this.workspaceList.teamList.unshift(resolve)
        this.activePromptCount++
        if (this.activePromptCount < this.inviteList.length) {
          this.inviteTitle = this.inviteList[this.activePromptCount].title
          this.intervalObj = setInterval(() => {
            this.activePrompt = true
            clearInterval(this.intervalObj)
          }, 1)
        } else {
          clearInterval(this.intervalObj)
        }
      }).catch(()=>{
        this.activePromptCount++
        if (this.activePromptCount < this.inviteList.length) {
          this.inviteTitle = this.inviteList[this.activePromptCount].title
          this.intervalObj = setInterval(() => {
            this.activePrompt = true
            clearInterval(this.intervalObj)
          }, 1)
        } else {
          clearInterval(this.intervalObj)
        }
      })
    },
    comp(val1, val2){
      return val1.update_time > val2.update_time;
    }
  },
  beforeDestroy() {
    this.activePrompt = false
  },
  created() {
    this.$vs.loading()
    this.$store.dispatch('space/getInvite')
    .then(() => {
      this.inviteList = this.$store.state.space.inviteList
      if(this.inviteList.length){
        this.inviteTitle = this.inviteList[this.activePromptCount].title
        this.activePrompt = true
      }
    })
    this.$store.dispatch('space/getAllWorkspace')
    .then(() => {
      var workspaceList = this.$store.state.space.workspaces
      for(var index = 0; index < workspaceList.length; index++){
        if (index < 4) {
          this.workspaceList.newList[index] = workspaceList[index]
        }
        if (workspaceList[index].alone == true){
          this.workspaceList.aloneList.push(workspaceList[index])
        }
        if (workspaceList[index].alone == false){
          this.workspaceList.teamList.push(workspaceList[index])
        }
      }
      this.$vs.loading.close()
    })
    .catch(() =>{
      this.$vs.loading.close()
    })

  }
}
</script>

<style lang="scss">
#demo-basic-card {
    .overlay-card {
        .vx-card__collapsible-content {
            max-height: 705px;
        }
    }
 }
</style>
